<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="edit-del-note" *ngIf="note && note.editMode!='Y'">
    <p>{{note.noteText}}</p>
    <div class="note-time-user">
        <span class="note-added-time">{{note.timestamp}}</span>
        <span class="note-added-by">{{note.userIdentifier}}</span>
        <div class="pull-right">
            <span><a href="javascript:;;" (click)="editNote()" *ngIf="(user && user.isUserManagerOrDirector)">Edit</a> </span>
            <span><a href="javascript:;;" (click)="deleteNoteData()" *ngIf="(user && user.isUserManagerOrDirector)">Delete</a> </span>
        </div>
    </div>
</div>
<div class="modify-notes" *ngIf="note && note.editMode==='Y' && tab && tab.mode==='edit'">

    <input id="editNoteTextBox{{index}}" tabindex="{{tabIndex}}" [(ngModel)]="note.editedNoteText" maxlength="62" style="text-transform:uppercase" class="{{note?.editedNoteText?.trim().length===0?'p-inputfield-error':''}}" type="text"
        value="note.noteText" (ngModelChange)="updateSearchText($event)">


    <div class="note-time-user">
        <span class="note-added-time"> {{note.timestamp}} </span> <span class="note-added-by"> {{note.userIdentifier}}</span></div>
</div>